import { fireLinkTag } from '#shared/features/analytics/tagManager';

export default function useStoreSlideout() {
  const navPreferred = useNavPreferred();

  function toggleSlideout() {
    navPreferred.toggleLocatorSlideout();
  }

  function openStoreSlideout() {
    toggleSlideout();
    fireLinkTag({
      event_name: 'shop your store drawer open',
      link_name: 'shop your store drawer open',
    });
  }

  return {
    openStoreSlideout,
    toggleSlideout,
  };
}
